import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import roFlag from '../images/romanianFlag.png';
import esFlag from '../images/spainFlag.png';
import enFlag from '../images/britainFlag.png';

const LanguageCard = () => {
  const { setLanguage, t } = useContext(LanguageContext);
  const handleChangeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <div className="max-w-[95vw] md:max-w-[500px] mx-auto mt-6 my-4 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex flex-col p-4 cursor-pointer">
      {/* Title from translations */}
      <h3 className="text-white font-bold mb-3">{t('txt.languageSelector')}</h3>
      
      {/* List of languages */}
      <div className="flex space-x-4">
        <button
          className="flex items-center space-x-2 text-white"
          onClick={() => handleChangeLanguage('ro')}
        >
          <img src={roFlag} alt="RO" className="w-6 h-6" />
          <span>Română</span>
        </button>

        <button
          className="flex items-center space-x-2 text-white"
          onClick={() => handleChangeLanguage('es')}
        >
          <img src={esFlag} alt="ES" className="w-6 h-6" />
          <span>Español</span>
        </button>

        <button
          className="flex items-center space-x-2 text-white"
          onClick={() => handleChangeLanguage('en')}
        >
          <img src={enFlag} alt="EN" className="w-6 h-6" />
          <span>English</span>
        </button>
      </div>

      {/*/!* Current selection *!/*/}
      {/*<p className="mt-3 text-sm text-white">*/}
      {/*  {t('txt.welcome')}! ({language.toUpperCase()})*/}
      {/*</p>*/}
    </div>
  );
};

export default LanguageCard;
